import type { Language } from "@/types/language";

export const languages: Language[] = [
  {
    id: 1,
    name: "English",
    locale: 'en',
    value: 1
  },
  {
    id: 2,
    name: "español",
    locale: 'es',
    value: 4
  },
  {
    id: 3,
    name: "हिंदी",
    locale: 'hi',
    value: 35
  },
  {
    id: 4,
    name: 'italiano',
    locale: 'it',
    value: 18
  },
  {
    id: 5,
    name: "คนไทย",
    locale: 'th',
    value: 33
  },
  {
    id: 6,
    name: "português",
    locale: 'pt_br',
    value: 23
  }
];
